import React from 'react';
import { useAccount } from '../../../shared/contexts/account/AccountContexts';
import ProjectsPreviewPage from './ProjectsPreviewPage';
import ProjectsPreviewPageV2 from './ProjectsPreviewPageV2';

/**
 * Picks which Project Preview page to render based on the NEW_STATS addon.
 * Accounts with NEW_STATS see the redesigned V2 page; everyone else keeps the
 * current page. Same route/URL — the swap is transparent to the user.
 */
const ProjectsPreviewPageSwitch: React.FC = () => {
  const { accountResponse } = useAccount();
  const hasNewStats = !!accountResponse?.addons?.includes('NEW_STATS');

  return hasNewStats ? <ProjectsPreviewPageV2 /> : <ProjectsPreviewPage />;
};

export default ProjectsPreviewPageSwitch;
